export const gtmChatEvent = (eventAction, eventLabel) => {
  window.dataLayer.push({
    event: "HSChatEvent",
    eventCategory: "Chat",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 1,
  });
}

export const gtmFormsEvent = (eventAction, eventLabel) => {
  window.dataLayer.push({
    event: "HSFormsEvent",
    eventCategory: "Form",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 1,
  });
}

export const gtmNavigationEvent = (eventAction, eventLabel) => {
  window.dataLayer.push({
    event: "HSFormsEvent",
    eventCategory: "Navigation",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 1,
  });
}

export const gtmProgramClickEvent = (eventContext, sectionTitle, clickText, clickUrl) => {
  window.dataLayer.push({
    event: "program_click",
    context: eventContext,
    section_title: sectionTitle,
    click_text: clickText,
    click_url: clickUrl,
  })
}

export const gtmFormEvent = (eventName, formElement, fieldName, buttonText, isFormSubmitted = false, additionalData = {}) => {
  const formName = formElement.querySelector('[data-form-name]').dataset.formName
  let currentStep = formElement.querySelector('[data-current-page]').dataset.currentPage
  if (isFormSubmitted) {
    currentStep = formElement.querySelector('[data-pages-count]').dataset.pagesCount
  }
  const pagesCount = formElement.querySelector('[data-pages-count]').dataset.pagesCount
  const step = pagesCount != 1 ? `step_${currentStep}` : false
  const eventObject = {
    event: eventName,
    form_name: formName,
  }

  if (fieldName) {
    eventObject.field_name = fieldName
  }
  if (step) {
    eventObject.steps = step
  }
  if (buttonText) {
    eventObject.buttonText = buttonText
  }

  window.dataLayer.push({...eventObject, ...additionalData})
}

export const gtmPushVisibleFields = (elements) => {
  Array.from(elements).forEach((input) => {
    if (input.type != 'hidden' && input.id != 'freeform_form_handle' && input.id != 'form_page_submit') {
      gtmFormsEvent('fallout', input.name)
    }
  });
}

export const gtmFormFieldFocusListener = (form) => {
  form.addEventListener('focus', (event) => {
    gtmFormsEvent('initiate', event.target.name)
  }, true);
}

export const gtmPushInPageNavigationOnClick = (querySelector) => {
  const navLinks = document.querySelector(querySelector).querySelectorAll(`[href]`)
  navLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      gtmNavigationEvent('In-page Navigation', event.target.innerText)
    });
  });
}

export const gtmPushProgramOnClick = (element) => {
  const programCards = element.querySelectorAll(`.program_card`)
  programCards.forEach((program) => {
    program.addEventListener('click', (event) => {
      let cardElement
      if (!event.target.classList.contains('program_card')) {
        cardElement = event.target.closest('.program_card')
      } else {
        cardElement = event.target
      }
      const context = cardElement.querySelector('.program_card_context').innerText
      const sectionTitle = cardElement.querySelector('.program_card_title').innerText
      const clickText = cardElement.querySelector('[href]').innerText
      const clickUrl = cardElement.querySelector('[href]').href
      gtmProgramClickEvent(context, sectionTitle, clickText, clickUrl)
    });
  });
}

export const gtmPushFormEventOnView = (formElement) => {
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        gtmFormEvent('form_view', formElement)
        observer.disconnect()
      }
    })
  }, {threshold: 0.01})

  observer.observe(formElement)
}

export const gtmPushFormEventsOnClick = (formElement) => {
  formElement.querySelectorAll('input, select, textarea').forEach(item => {
    item.addEventListener('click', () => {
      if (!formElement.firstTimeInteracted) {
        gtmFormEvent('form_initiate', formElement)
        formElement.firstTimeInteracted = true
      }
    })
  })

  formElement.querySelectorAll('button').forEach(button => {
    button.addEventListener('click', (event) => {
      const buttonText = event.target.innerText
      gtmFormEvent('form_button', formElement, false, buttonText)
    })
  })
}

export const gtmPushFormEventsOnFocusout = (formElement) => {
  formElement.querySelectorAll('input, select, textarea').forEach(item => {
    item.addEventListener('focusout', event => {
      if (!event.target.fallout) {
        const fieldName = event.target.name
        gtmFormEvent('form_fallout', formElement, fieldName)
        event.target.fallout = true
      }
    })
  })
}

export const gtmSaveFieldValuesForSubmit = (formElement) => {
  window.gtmFieldValues = window.gtmFieldValues || {}

  const emailField = formElement.querySelector('[name="email"]')
  if (emailField) {
    window.gtmFieldValues.email = emailField.value.trim().toLowerCase()
  }

  const zipField = formElement.querySelector('[name="postal_zip_code"]')
  const zipField2 = formElement.querySelector('[name="zip"]')
  if (zipField) {
    window.gtmFieldValues.zip = zipField.value.trim().toLowerCase()
  } else if (zipField2) {
    window.gtmFieldValues.zip = zipField.value.trim().toLowerCase()
  }

  const hiddenPhoneField = formElement.querySelector('[name="phone"][type="hidden"]')
  const phoneField = formElement.querySelector('[name="phone"][type="tel"]')
  const mobilephoneField = formElement.querySelector('[name="mobilephone"]')
  if (hiddenPhoneField) {
    window.gtmFieldValues.phone = hiddenPhoneField.value
  } else if (phoneField) {
    window.gtmFieldValues.phone = phoneField.value.replace(/[^0-9]/g, '')
  } else if (mobilephoneField) {
    window.gtmFieldValues.phone = mobilephoneField.value.replace(/[^0-9]/g, '')
  }

  const firstNameField = formElement.querySelector('[name="firstname"]')
  if (firstNameField) {
    window.gtmFieldValues.firstname = firstNameField.value.replace(/[^a-zA-Z]/g, '').toLowerCase()
  }

  const lastNameField = formElement.querySelector('[name="lastname"]')
  if (lastNameField) {
    window.gtmFieldValues.lastname = lastNameField.value.replace(/[^a-zA-Z]/g, '').toLowerCase()
  }

  const countryField = formElement.querySelector('[name="country"]')
  if (countryField && countryField.offsetHeight > 0) {
    window.gtmFieldValues.country = countryField.value.replace(/[^a-zA-Z]/g, '').toLowerCase()
  }

  const cityField = formElement.querySelector('[name="city"]')
  if (cityField) {
    window.gtmFieldValues.city = cityField.value.replace(/[^a-zA-Z]/g, '').toLowerCase()
  }
}

export const gtmPushFormEventsOnSubmit = (formElement) => {
  window.gtmFieldValues = window.gtmFieldValues || {}
  const additionalData = {...window.gtmFieldValues}

  gtmFormEvent('form_submit', formElement, false, false, true, additionalData)
}

export const gtmAttachClassesToDomElements = () => {
  document.querySelectorAll('a').forEach((element) => {
    const href = element.href
    const classList = element.classList
    const innerHTML = element.innerHTML.toLowerCase()
    if (href.includes('mailto:') && !classList.contains('contact_emailto')) {
      element.classList.add('contact_emailto')
    } else if (href.includes('#hs-chat-open') && !classList.contains('contact_chat')) {
      element.classList.add('contact_chat')
    } else if (href.includes('tel:') && !classList.contains('contact_phone')) {
      element.classList.add('contact_phone')
    } else if (innerHTML.includes('contact') && classList.contains('btn') && !classList.contains('contact_btn')) {
      element.classList.add('contact_btn')
    } else if (innerHTML.includes('download') && !classList.contains('download')) {
      element.classList.add('download')
    } else if (['glassdoor', 'coursereport'].some(phrase => href.includes(phrase)) && !classList.contains('social_share')) {
      element.classList.add('social_share')
    } else if (['apply', 'take practice', 'find your', 'request syllabus', 'start your', 'view payment'].some(phrase => innerHTML.includes(phrase)) && !classList.contains('site_cta')) {
      element.classList.add('site_cta')
    }
  })

  document.querySelectorAll('.hero_links a, .hero_links button').forEach((element) => {
    element.classList.add('banner_link')
  })
}

export const gtmDetectWistiaIframeAndAttachFiringEvents = (querySelector) => {
  const initializeCallbacks = (elementId) => {
    const wistiaApi = Wistia.api(elementId)
    let videoStarted = false
    wistiaApi.bind('play', () => {
      const videoTitle = wistiaApi.name()
      const videoUrl = wistiaApi.iframe?.dataset.src ?? ''
      if (videoStarted) {
        window.dataLayer.push({
          event: "video_play",
          video_title: videoTitle,
          video_url: videoUrl
        })
      } else {
        window.dataLayer.push({
          event: "video_start",
          video_title: videoTitle,
          video_url: videoUrl
        })
        videoStarted = true
      }

    })

    wistiaApi.bind('pause', () => {
      const videoTitle = wistiaApi.name()
      const videoUrl = wistiaApi.iframe?.dataset.src ?? ''
      window.dataLayer.push({
        event: "video_pause",
        video_title: videoTitle,
        video_url: videoUrl
      })
    })

    //Video Progress
    wistiaApi.bind('secondchange', (videoTime) => {
      const videoTitle = wistiaApi.name()
      const videoUrl = wistiaApi.iframe?.dataset.src ?? ''
      const percent = videoTime / wistiaApi.duration()
      let reachedMilestone = false
      let progressPercent = []
      if (percent >= .25 && percent < 1 && wistiaApi.percent25 != true) {
        reachedMilestone = true
        wistiaApi.percent25 = true
        progressPercent.push('25%')
      }
      if (percent >= .50 && percent < 1 && wistiaApi.percent50 != true) {
        reachedMilestone = true
        wistiaApi.percent50 = true
        progressPercent.push('50%')
      }
      if (percent >= .75 && percent < 1 && wistiaApi.percent75 != true) {
        reachedMilestone = true
        wistiaApi.percent75 = true
        progressPercent.push('75%')
      }
      if (reachedMilestone) {
        progressPercent.forEach(percent => {
          window.dataLayer.push({
            event: "video_progress",
            video_title: videoTitle,
            video_url: videoUrl,
            progress_percent: percent
          })
        })
      }
    })

    //Video Complete
    wistiaApi.bind("end", function () {
      const videoTitle = wistiaApi.name()
      const videoUrl = wistiaApi.iframe?.dataset.src ?? ''
      if (wistiaApi.percent100 != true) {
        wistiaApi.percent100 = true
        window.dataLayer.push({
          event: "video_progress",
          video_title: videoTitle,
          video_url: videoUrl,
          progress_percent: '100%'
        })
      }
      window.dataLayer.push({
        event: "video_completed",
        video_title: videoTitle,
        video_url: videoUrl
      })
    });
  }

  const iframeQuerySelector = querySelector || 'iframe[src*="wistia"]'

  const iframeElements = document.querySelectorAll(iframeQuerySelector)
  if (iframeElements.length > 0) {
    let wistiaApiScript = document.createElement('script')
    wistiaApiScript.type = 'text/javascript'
    wistiaApiScript.src = '//fast.wistia.net/assets/external/iframe-api-v1.js'
    wistiaApiScript.defer = true
    document.head.appendChild(wistiaApiScript)

    wistiaApiScript.addEventListener('load', () => {
      iframeElements.forEach((iframeElement) => {
        const iframeId = `wistia_` + (Math.random() + 1).toString(36).substring(7)
        iframeElement.id = iframeId
        initializeCallbacks(iframeElement.id)
      })
    })
  }

  const embedElements = document.querySelectorAll('[class*="wistia_async_"]')
  if (embedElements.length > 0) {
    window._wq = window._wq || [];
    _wq.push({
      id: "_all", onReady: function (video) {
        initializeCallbacks(video._containerId)
      }
    })
  }
}

export const gtmDetectYoutubeIframeAndAttachFiringEvents = (querySelector) => {
  const initializeCallbacks = (elementId) => {
    window[elementId] = new YT.Player(elementId)
    clearInterval(window.ytTimer)

    window[elementId].addEventListener('onStateChange', (event) => {
      const videoTitle = event.target.videoTitle
      const videoUrl = event.target.playerInfo.videoUrl
      if (event.data == YT.PlayerState.UNSTARTED) {
        window.dataLayer.push({
          event: "video_start",
          video_title: videoTitle,
          video_url: videoUrl
        })
      }
      if (event.data == YT.PlayerState.PLAYING) {
        window.dataLayer.push({
          event: "video_play",
          video_title: videoTitle,
          video_url: videoUrl
        })
      }
      if (event.data == YT.PlayerState.PAUSED) {
        window.dataLayer.push({
          event: "video_pause",
          video_title: videoTitle,
          video_url: videoUrl
        })
      }
      if (event.data == YT.PlayerState.ENDED) {
        window.dataLayer.push({
          event: "video_completed",
          video_title: videoTitle,
          video_url: videoUrl
        })
      }

      if (event.data == YT.PlayerState.PLAYING) {
        window.ytTimer = setInterval(() => {
          const percent = window[elementId].playerInfo.currentTime / window[elementId].playerInfo.duration
          let reachedMilestone = false
          let progressPercent = []
          if (percent >= .25 && percent < 1 && window[elementId].percent25 != true) {
            reachedMilestone = true
            window[elementId].percent25 = true
            progressPercent.push('25%')
          }
          if (percent >= .50 && percent < 1 && window[elementId].percent50 != true) {
            reachedMilestone = true
            window[elementId].percent50 = true
            progressPercent.push('50%')
          }
          if (percent >= .75 && percent < 1 && window[elementId].percent75 != true) {
            reachedMilestone = true
            window[elementId].percent75 = true
            progressPercent.push('75%')
          }
          if (reachedMilestone) {
            progressPercent.forEach(percent => {
              window.dataLayer.push({
                event: "video_progress",
                video_title: videoTitle,
                video_url: videoUrl,
                progress_percent: percent
              })
            })
          }
        }, 1000)
      }
      if (event.data == YT.PlayerState.PAUSED || event.data == YT.PlayerState.ENDED) {
        clearInterval(window.ytTimer)
      }
      if (event.data == YT.PlayerState.ENDED) {
        if (window[elementId].percent100 != true) {
          window[elementId].percent100 = true
          window.dataLayer.push({
            event: "video_progress",
            video_title: videoTitle,
            video_url: videoUrl,
            progress_percent: '100%'
          })
        }
      }
    })
  }

  const iframeQuerySelector = querySelector || 'iframe[src*="youtube"]'

  const iframeElements = document.querySelectorAll(iframeQuerySelector)
  if (iframeElements.length > 0) {
    if (typeof YT !== 'undefined') {
      iframeElements.forEach((iframeElement) => {
        const iframeId = `youtube_` + (Math.random() + 1).toString(36).substring(7)
        iframeElement.id = iframeId
        initializeCallbacks(iframeElement.id)
      })
    } else {
      let youtubeApiScript = document.createElement('script')
      youtubeApiScript.type = 'text/javascript'
      youtubeApiScript.src = '//www.youtube.com/iframe_api'
      youtubeApiScript.defer = true
      document.head.appendChild(youtubeApiScript)

      window.onYouTubeIframeAPIReady = () => {
        window.iframeApiLoaded = true
        iframeElements.forEach((iframeElement) => {
          const iframeId = `youtube_` + (Math.random() + 1).toString(36).substring(7)
          iframeElement.id = iframeId
          initializeCallbacks(iframeElement.id)
        })
      }
    }
  }

  const videoTabsContainers = document.querySelectorAll('.video_tabs')
  if (videoTabsContainers.length > 0 && !window.videoTabsObserversAdded) {
    videoTabsContainers.forEach((videoTabsContainer) => {
      const observer = new MutationObserver(() => {
        const iframeElement = videoTabsContainer.querySelector('iframe:not([class="lazyload"])')
        if (iframeElement) {
          const iframeId = `youtube_` + (Math.random() + 1).toString(36).substring(7)
          iframeElement.id = iframeId
          initializeCallbacks(iframeElement.id)
        }
      })

      observer.observe(videoTabsContainer, {childList: true, subtree: true})
    })
    window.videoTabsObserversAdded = true
  }
}

export const gtmPushEventsOnPageLoad = () => {
  const pageType = document.querySelector('meta[name="dl-page-type"]')
  const program = document.querySelector('meta[name="dl-program"]')

  window.dataLayer = window.dataLayer || []
  if (pageType) {
    window.dataLayer.push({
      pageType: pageType.content
    })
  }
  if (program) {
    window.dataLayer.push({
      program: program.content
    })
  }
}

export const gtmPushEventsOnElementClick = () => {
  const menuNavigationLinks = document.querySelectorAll('.menu_link')
  const accordionLinks = document.querySelectorAll('.accordion_link')
  const socialLinks = document.querySelectorAll('.social_link')
  const blogPostLinks = document.querySelectorAll('.blog_link')

  menuNavigationLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const topNavItem = event.currentTarget.closest('.top_navItem')
      const topNavLink = topNavItem.querySelector('.top_navLink')
      window.dataLayer.push({
        event: "menu_navigation_click",
        header_title: topNavLink.innerText,
        click_text: event.currentTarget.innerText.replace('\n', " "),
        click_url: event.currentTarget.href,
      })
    })
  })

  accordionLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const heading = event.currentTarget.querySelector('.accordion_heading').innerText
      window.dataLayer.push({
        event: "accordion_click",
        click_text: heading.replace('\n', " "),
      })
    })
  })

  socialLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      window.dataLayer.push({
        event: "social_click",
        click_text: event.currentTarget.dataset.icon,
        click_url: event.currentTarget.href,
      })
    })
  })

  blogPostLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const text = event.currentTarget.querySelector('h3')

      window.dataLayer.push({
        event: "blog_post_click",
        click_text: text.innerText,
        click_url: event.currentTarget.href,
      })
    })
  })
}

export const gtmPushDigitalExperience = (selectedOption) => {
  if (selectedOption) {
    window.dataLayer.push({
      event: "digital_experience_item_selection",
      click_text: selectedOption.innerText,
      click_option: selectedOption.dataset.targetOption ?? '',
      click_slide: selectedOption.dataset.targetSlide ?? '',
      click_url: selectedOption.dataset.targetSlideContainerLink ?? '',
    })
  }
}